import { InstagramLogo, MapPin } from "@phosphor-icons/react";
import LogoMark from "@/components/LogoMark";
import { scrollToSection } from "@/components/Reveal";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative overflow-hidden border-t border-[#112E4A] bg-[#071526]">
      <div className="mx-auto max-w-[1440px] px-6 pb-10 pt-20 md:px-12 md:pt-28">
        <div className="flex flex-col items-start justify-between gap-10 md:flex-row md:items-center">
          <div className="flex items-center gap-4">
            <LogoMark size={40} color="#A8C6E8" />
            <div>
              <div className="font-display text-lg font-medium tracking-[0.18em] text-[#FAFAFA]">
                WOFERS <span className="text-[#A8C6E8]">GLOBAL</span>
              </div>
              <div className="mt-1 text-[10px] uppercase tracking-[0.3em] text-[#94A3B8]">
                Tbilisi · Georgia
              </div>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3" data-testid="footer-nav">
            {[
              ["Services", "#services", "footer-services-link"],
              ["Why Georgia", "#georgia", "footer-georgia-link"],
              ["Partners", "#partners", "footer-partners-link"],
              ["Contact", "#contact", "footer-contact-link"],
              ["Partnership Deck", "/wofers-global-partnership-deck.pdf", "footer-deck-link"],
            ].map(([label, href, testId]) => (
              <a
                key={href}
                href={href}
                data-testid={testId}
                {...(href.endsWith(".pdf") ? { download: true } : { onClick: (e) => scrollToSection(e, href) })}
                className="text-xs font-medium uppercase tracking-[0.2em] text-[#94A3B8] transition-colors duration-300 hover:text-[#A8C6E8]"
              >
                {label}
              </a>
            ))}
          </nav>
        </div>

        <div
          data-testid="footer-wordmark"
          aria-hidden="true"
          className="mt-16 select-none whitespace-nowrap text-center font-display text-[clamp(3rem,12.5vw,12rem)] font-light leading-[0.85] tracking-tight text-white/10 md:mt-20"
        >
          WOFERS GLOBAL
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-8 text-xs font-light text-[#94A3B8] lg:flex-row lg:items-center">
          <span data-testid="footer-copyright">© 2026 WOFERS GLOBAL. All rights reserved.</span>
          <span data-testid="footer-address" className="inline-flex items-center gap-2">
            <MapPin size={14} weight="light" className="text-[#A8C6E8]" />
            34 Abashidze Street, Tbilisi, Georgia
          </span>
          <div className="flex flex-wrap items-center gap-5 lg:pr-24">
            <a
              href="https://www.instagram.com/wofersglobal/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-english-link"
              className="inline-flex items-center gap-2 transition-colors duration-300 hover:text-[#A8C6E8]"
            >
              <InstagramLogo size={14} weight="light" />
              @wofersglobal
            </a>
            <a
              href="https://www.instagram.com/wofers.co/"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-instagram-arabic-link"
              className="inline-flex items-center gap-2 transition-colors duration-300 hover:text-[#A8C6E8]"
            >
              <InstagramLogo size={14} weight="light" />
              @wofers.co
            </a>
            <a
              href="mailto:wofersglobal@gmail.com"
              data-testid="footer-email-link"
              className="transition-colors duration-300 hover:text-[#A8C6E8]"
            >
              wofersglobal@gmail.com
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
